import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { ServiceMapData } from '../../types';

/**
 * Export service map relationships to a single CSV file.
 * Required columns:
 * - source
 * - source_type
 * - connection
 * - target
 * - target_type
 */
export const exportToCSV = async (
  exportData: ServiceMapData,
  onSuccess: (message: string) => void,
  onError: (message: string) => void
): Promise<void> => {
  if (!exportData.edges || exportData.edges.length === 0) {
    onError('Cannot export: No relationships found in the diagram.');
    return;
  }

  try {
    const csvRows = exportData.edges.map(edge => {
      const sourceNode = exportData.nodes.find(n => n.id === edge.source);
      const targetNode = exportData.nodes.find(n => n.id === edge.target);

      return {
        source: sourceNode?.name || edge.source,
        source_type: sourceNode?.type || 'UNKNOWN',
        connection: edge.relationshipType,
        target: targetNode?.name || edge.target,
        target_type: targetNode?.type || 'UNKNOWN',
      };
    });

    const timestamp = new Date().toISOString().slice(0, 16).replace(/[:-]/g, '');
    const fileBaseName = (exportData.metadata.name || 'service_map').replace(/[^a-zA-Z0-9]/g, '_');
    const csvContent = Papa.unparse(csvRows, {
      columns: ['source', 'source_type', 'connection', 'target', 'target_type'],
    });

    saveAs(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }), `${fileBaseName}_relationships_${timestamp}.csv`);

    onSuccess(`CSV export successful! Exported ${csvRows.length} relationship row(s).`);
  } catch (error) {
    onError('Error generating CSV file. Please try again.');
  }
};
